import * as yup from 'yup';

export const locationSchema = yup
    .object()
    .shape({
        projectLocation: yup.string().required('Please enter project address'),
        state: yup.object().required('Please select state'),
        city: yup.object().required('Please select city'),

    })    